import Alpine from 'alpinejs';
import { VideoFavorite } from './video_favorite';

Alpine.data('videoFavorite', (initialFavoriteState: boolean = false) => new VideoFavorite(initialFavoriteState)); 